import {IonAvatar, IonButton, IonButtons, IonChip, IonCard, IonCardContent, IonText, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonTitle, IonToolbar, RefresherEventDetail, useIonModal, useIonRouter, IonItem, IonThumbnail, useIonLoading} from '@ionic/react';
import {useStoreState} from 'pullstate';

import styles_8_4 from "./Pg_8_4.module.scss";
import styles_A_0 from './Pg_A_0.module.scss';
import {getPageData} from "../store/Selectors";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {chevronDownCircleOutline, personCircle} from "ionicons/icons";
import {useAppUtil, useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import CustomPage from "./CustomPage";
import {useFormInput, validateForm} from "../_/useForms";
import indexBy from "underscore/modules/indexBy";
import {handleCommonFetchErrors, navToPg_2_3, navToPg_7_5, promptBrowserToLogin} from "./Utils";
import Ln_TokenPictureSetCoverImg from "./Ln_TokenPictureSetCoverImg";
import moment from "moment/moment";
import styles_Common from "./Common.module.scss";
import CustomField from "../components/CustomField";
import {AuthStore} from "../store/Common_Store";
import {fetch_Pg_7_1, Pg_7_1_Store, push_pg_7_3_1_JoinEvent} from "../store/Pg_7_Store";

import Slider from "react-slick";
import styles_4_2 from "./Pg_4_2.module.scss";
import {ActionLink} from "../components/ActionLink";
import classNames from 'classnames';
import AriaModal from "../components/react-aria-modal/src/react-aria-modal";
import useForceRender from "../_/useForceRender";
import styles from "./Common.module.scss";
import logo from "../srcicons/logo.svg";
import styles_8_1 from "./Pg_8_1.module.scss";
import {Modal_0_24_VenderRedeem} from "./Modal_0_24_VenderRedeem";
import {fetch_Pg_8_4, Pg_8_4_Store, Pg_8_5_Store, push_pg_8_4, push_pg_8_4__exportexcel, push_pg_8_5, push_pg_8_5__exportexcel} from "../store/Pg_8_Store";

const customSelectContainerOptions_您的寵物名字 = {
    header: '您的寵物名字',
    subHeader: '',
    message: '請選擇一項',
    translucent: false,
};


const customSelectContainerOptions_選取風格 = {
    header: '選取風格',
    subHeader: '',
    message: '請選擇一項',
    translucent: false,
};


const DateForm = ({
                      StartDate,
                      EndDate,
                      hasAuthed,
                      reload,
                      errors
                  }) => {
    const useMyFields = () => {
        return [
            {
                id: "p1",
                label: "交易開始日期",
                required: true,
                input: {
                    props: {
                        type: "text",
                        placeholder: "交易開始日期",

                    },
                    state: useFormInput(new Date(StartDate).toJSON())
                }
            },
            {
                id: "p2",
                label: "交易結束日期",
                required: true,
                input: {
                    props: {
                        type: "text",
                        placeholder: "交易結束日期",

                    },
                    state: useFormInput(new Date(EndDate).toJSON())
                }
            },
        ];
    }

    const fields = useMyFields();
    let keyedFields = indexBy(fields, 'id');

    const [presentLoading, dismissLoading] = useIonLoading();

    const pgData = useStoreState(Pg_8_4_Store, getPageData);

    const _push_pg_8_4 = async () => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        //clear other states
        Pg_8_4_Store.update(s => {
            Object.assign(s, {
                ExportExcel: null,
            })
        });

        let p1 = fields && (keyedFields.p1 as any).input.state.value;
        let p2 = fields && (keyedFields.p2 as any).input.state.value;

        function removeTimeZoneWithZ(dateString) {
            return dateString.replace(/([+-]\d{2}:\d{2})$/, 'Z'); // Removes timezone offset with Z
        }

        p1 = removeTimeZoneWithZ(p1);
        p2 = removeTimeZoneWithZ(p2);

        try {
            presentLoading({
                message: '讀取中...',
                //duration: 3000,
            });
            if (await push_pg_8_4({
                p1: p1,
                p2: p2,
            })) {
                dismissLoading();
                //navToPg_1_1();
                //await reload();

                // presentAlert({
                //     backdropDismiss: true,
                //     keyboardClose: true,
                //     header: '歡迎您參與活動！',
                //     //subHeader: 'A Sub Header Is Optional',
                //     message: Item_Sdgs活動.活動名稱,
                //     buttons: [
                //         {
                //             text: '查詢積分紀錄',
                //             role: 'confirm',
                //             handler: () => {
                //                 navToPg_7_5(router);
                //             },
                //         },
                //         {
                //             text: '了解',
                //             role: 'cancel',
                //             handler: () => {
                //                 //reload();
                //             },
                //         },
                //     ]
                // })
            } else {
                dismissLoading();
            }
        } catch (err) {
            dismissLoading();
            throw err;
        }
    }


    const _push_pg_8_4__downloadFile = async (url) => {
        window.open(url, '_blank');
    }
    const _push_pg_8_4__exportexcel = async () => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        let p1 = fields && (keyedFields.p1 as any).input.state.value;
        let p2 = fields && (keyedFields.p2 as any).input.state.value;

        function removeTimeZoneWithZ(dateString) {
            return dateString.replace(/([+-]\d{2}:\d{2})$/, 'Z'); // Removes timezone offset with Z
        }

        p1 = removeTimeZoneWithZ(p1);
        p2 = removeTimeZoneWithZ(p2);


        try {
            presentLoading({
                message: '讀取中...',
                //duration: 3000,
            });

            if (await push_pg_8_4__exportexcel({
                p1: p1,
                p2: p2,
            })) {
                dismissLoading();
                //navToPg_1_1();
                //await reload();

                // presentAlert({
                //     backdropDismiss: true,
                //     keyboardClose: true,
                //     header: '歡迎您參與活動！',
                //     //subHeader: 'A Sub Header Is Optional',
                //     message: Item_Sdgs活動.活動名稱,
                //     buttons: [
                //         {
                //             text: '查詢積分紀錄',
                //             role: 'confirm',
                //             handler: () => {
                //                 navToPg_7_5(router);
                //             },
                //         },
                //         {
                //             text: '了解',
                //             role: 'cancel',
                //             handler: () => {
                //                 //reload();
                //             },
                //         },
                //     ]
                // })
            } else {
                dismissLoading();
            }
        } catch (err) {
            dismissLoading();
            throw err;
        }
    }

    return <React.Fragment key="8_4">
        {keyedFields.p1.label}:
        <CustomField textType="datePicker" inputClassName={styles_8_4.field} key={keyedFields.p1.id} field={keyedFields.p1} errors={errors}/>

        {keyedFields.p2.label}:
        <CustomField textType="datePicker" inputClassName={styles_8_4.field} key={keyedFields.p2.id} field={keyedFields.p2} errors={errors}/>

        <IonButton className="custom-button" expand="block" onClick={_push_pg_8_4}>查詢</IonButton>
        {(pgData?.Root?.List_會員積分點數流水?.length > 0) && <React.Fragment>

            {(pgData?.ExportExcel) ?
                <IonButton className="custom-button" expand="block" onClick={() => _push_pg_8_4__downloadFile(pgData.ExportExcel.Filename)}>下載 {pgData.ExportExcel.Filename}</IonButton>
                :
                <IonButton className="custom-button" expand="block" onClick={_push_pg_8_4__exportexcel}>匯出搜尋結果 (Excel)</IonButton>
            }

        </React.Fragment>}
    </React.Fragment>
}

const Pg_8_4 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_8_4";
    const pageId = "Pg_8_4";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const forceRender = useForceRender();

    const router = useIonRouter();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    //const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    const [errors, setErrors] = useState(false);


    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    //#region Data Loading
    useEffect(() => {
        (async () => {
            let errorObj = await fetch_Pg_8_4();
            handleCommonFetchErrors(router, errorObj);
        })();
    }, []);

    let reload = async (event?: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        let errorObj = await fetch_Pg_8_4();
        handleCommonFetchErrors(router, errorObj);
        event?.detail?.complete();
    }

    const pgData = useStoreState(Pg_8_4_Store, getPageData);

    const hasLoaded = pgData?.Root ?? false;

    const List_會員積分點數流水 = hasLoaded ? pgData.Root.List_會員積分點數流水 : undefined;
    const StartDate = hasLoaded ? pgData.Root.StartDate : undefined;
    const EndDate = hasLoaded ? pgData.Root.EndDate : undefined;
    const List_會員積分點數流水_Count = hasLoaded ? pgData.Root.List_會員積分點數流水_Count : undefined;
    const Item_會員 = hasLoaded ? pgData.Box_Header.Item_會員 : undefined;

    if (hasLoaded) {
        //debugger;

    }

    //#endregion

    const navToPg_3_1 = () => {
        router.push("/tabs/3_1", "forward", "push");
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }


    let 兌換 = 0;
    let 領取 = 0;
    let 碳權 = 0.0;
    if (hasLoaded) {
        List_會員積分點數流水?.map((Item_會員積分點數流水: any) => {
            if (Item_會員積分點數流水._兌換紀錄) {
                兌換++;

                if (Item_會員積分點數流水._兌換紀錄.Is實體交易完成) {
                    領取++;


                    碳權 += Number.parseFloat(Item_會員積分點數流水._ProductModel.ProductCarbonCredit);
                }
            }
        });
    }


    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={false}>
                <IonRefresher slot="fixed" onIonRefresh={reload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>

                {!hasLoaded && <Fragment>
                    <>
                        {/*<IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">*/}
                        {/*    <div>*/}
                        {/*        讀取中，讀取可能牽涉到AI計算，請稍後*/}
                        {/*    </div>*/}
                        {/*</IonGrid>*/}
                    </>
                </Fragment>}

                {hasLoaded && <Fragment>
                    {/*<BannerTopSwipe/>*/}
                    <>
                        {!Item_會員 &&
                            <IonGrid>
                                <IonRow>
                                    <IonCol className="ion-justify-content-center ion-text-center w100 ion-padding">
                                        未登錄，登入後即可使用 AI生圖功能
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        }

                        <IonGrid className="ion-padding">
                            <IonRow>
                                <IonCol size="12" className={styles_8_4.headingText}>
                                    <IonCardTitle color="primary">非交易碳權紀錄</IonCardTitle>
                                    {/*<h4>未來創藝股份有限公司 ！ 登出</h4>*/}
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                        <IonGrid>
                            {/*<IonCardHeader>*/}
                            {/*    <IonCardTitle>商品兌換紀錄</IonCardTitle>*/}
                            {/*    /!*<IonCardSubtitle>Card Subtitle</IonCardSubtitle>*!/*/}
                            {/*</IonCardHeader>*/}
                            <IonCardContent>
                                {/*<div className={classNames("fl", styles_Common.footerText)}>*/}
                                {/*    <div>紀錄查詢</div>*/}
                                {/*    <div>匯出Excel檔</div>*/}
                                {/*    <div>掃瞄器</div>*/}
                                {/*</div>*/}

                                {/*<IonList>*/}
                                {/*    <IonItem>*/}
                                {/*        <IonThumbnail slot="start">*/}
                                {/*            <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                                {/*        </IonThumbnail>*/}
                                {/*        <IonLabel>Item</IonLabel>*/}
                                {/*    </IonItem>*/}
                                {/*</IonList>*/}

                                <IonCol size="12">
                                    <DateForm StartDate={StartDate} EndDate={EndDate} hasAuthed={hasAuthed} reload={reload} errors={errors}/>

                                    {/*{keyedFields.p1.label}:*/}
                                    {/*<CustomField textType="datePicker" inputClassName={styles_8_4.field} key={keyedFields.p1.id} field={keyedFields.p1} errors={errors}/>*/}

                                    {/*{keyedFields.p2.label}:*/}
                                    {/*<CustomField textType="datePicker"  inputClassName={styles_8_4.field} key={keyedFields.p2.id} field={keyedFields.p2} errors={errors}/>*/}

                                    {/*<IonButton className="custom-button" expand="block" onClick={_push_pg_8_4}>查詢</IonButton>*/}
                                    {/*<div className="ion-text-center ion-margin-top ion-padding-top">*/}
                                    {/*    <ActionLink link={`/B_1`}><IonText>忘記密碼</IonText></ActionLink> | <ActionLink link={`/C_1`}><IonText>註冊帳號</IonText></ActionLink>*/}
                                    {/*</div>*/}
                                </IonCol>
                            </IonCardContent>
                        </IonGrid>



                        {List_會員積分點數流水 ?
                            <IonGrid id="SearchResult" className={styles_8_4.searchResultContainer}>
                                <IonCardHeader>
                                    <IonCardTitle>搜尋結果</IonCardTitle>
                                    <IonCardSubtitle className={styles_8_4.searchResultContainer__subTitle}>{moment(StartDate).format('YYYY/MM/DD')}~{moment(EndDate).format('YYYY/MM/DD')} 共有 {兌換} 筆（兌換），{領取} 筆（領取），碳權加總 {碳權.toFixed(2)} kgCO2e / NTCC</IonCardSubtitle>
                                </IonCardHeader>
                            </IonGrid>
                            :
                            <IonGrid id="SearchResult" className={styles_8_4.searchResultContainer}>
                                <IonCardHeader>
                                    <IonCardTitle>點選查詢開始搜尋</IonCardTitle>
                                </IonCardHeader>
                            </IonGrid>
                        }



                        {List_會員積分點數流水 && List_會員積分點數流水.map((Item_會員積分點數流水: any) => {
                            return <IonCard key={Item_會員積分點數流水.會員積分點數流水Id} className={classNames(styles_8_1.cardContainer)}>
                                <IonCardHeader>
                                    <IonCardTitle>{Item_會員積分點數流水.事件當時品項與規格}</IonCardTitle>
                                    {/*<IonCardSubtitle>Card Subtitle</IonCardSubtitle>*/}
                                </IonCardHeader>
                                <IonCardContent>
                                    <IonList>
                                        <IonItem>
                                            {/*<IonThumbnail slot="start">*/}
                                            {/*    <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                                            {/*</IonThumbnail>*/}
                                            <IonLabel>紀錄流水Id: {Item_會員積分點數流水.會員積分點數流水Id}</IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            {/*<IonThumbnail slot="start">*/}
                                            {/*    <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                                            {/*</IonThumbnail>*/}
                                            <IonLabel>商品規格Id: {Item_會員積分點數流水._兌換紀錄.ProductModelId}</IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>兌換者會員Id: {Item_會員積分點數流水._兌換紀錄.會員Id}</IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            {/*<IonThumbnail slot="start">*/}
                                            {/*    <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                                            {/*</IonThumbnail>*/}
                                            <IonLabel>領取狀況: {Item_會員積分點數流水._兌換紀錄.Is實體交易完成 ? '是' : '否'}</IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>領取時間: {Item_會員積分點數流水._兌換紀錄.Is實體交易完成 && moment(Item_會員積分點數流水._兌換紀錄.實體交易時間).format('YYYY/MM/DD hh:mm')}</IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>領取註記: {Item_會員積分點數流水._兌換紀錄.Is實體交易完成 && Item_會員積分點數流水._兌換紀錄.實體交易註記}</IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>產生碳權: {Item_會員積分點數流水._ProductModel.ProductCarbonCredit} kgCO2e / NTCC</IonLabel>
                                        </IonItem>
                                    </IonList>
                                </IonCardContent>
                            </IonCard>
                        })}
                    </>
                </Fragment>
                }

                {/*<IonGrid className={classNames("ion-padding", styles_Common.footer)}>*/}
                {/*    <div className={styles_Common.footerInnerContainer}>*/}
                {/*        <IonRow>*/}
                {/*            <IonCol size="12">*/}
                {/*                <IonIcon className={classNames(styles_Common.footerIcon, "fl")} src={logo}></IonIcon>*/}
                {/*                <IonIcon className={classNames(styles_Common.footerIcon, "fr")} src="/assets/icon/logo-youtube.svg"></IonIcon>*/}
                {/*            </IonCol>*/}
                {/*        </IonRow>*/}

                {/*        <IonRow>*/}
                {/*            <IonCol size="12" className={styles_Common.footerTextContainer}>*/}
                {/*                <div className={classNames("fl", styles_Common.footerText)}>*/}
                {/*                    <div>EMJ</div>*/}
                {/*                    <div>PetJourney.ai</div>*/}
                {/*                    <div>SDGs Passport</div>*/}
                {/*                    <div>xxxxxxxxx</div>*/}
                {/*                </div>*/}
                {/*            </IonCol>*/}
                {/*        </IonRow>*/}
                {/*    </div>*/}
                {/*</IonGrid>*/}
            </CustomPage>

        </IonPage>
    );
};

export default Pg_8_4;
